// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BalanceHomeBrowseViewScreenEvent
 */
export var BalanceHomeBrowseViewScreen = function () { return ({
    name: "BalanceHome Browse ViewScreen",
    parameters: {
        cdf_entity: "BalanceHome",
        cdf_action: "Browse",
    }
}); };
/**
 * @see BalanceHomeBrowseTapBankingOptionEvent
 *
 * @deprecated This event is obsolete. Use BankingOptionBrowseTapItem instead.
 */
export var BalanceHomeBrowseTapBankingOption = function (_a) {
    var bankingOptionId = _a.bankingOptionId;
    return ({
        name: "BalanceHome Browse TapBankingOption",
        parameters: {
            cdf_entity: "BalanceHome",
            cdf_action: "Browse",
            BankingOptionId: bankingOptionId !== undefined && bankingOptionId !== null ? bankingOptionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BalanceHomeBrowseTapElementEvent
 */
export var BalanceHomeBrowseTapElement = function (_a) {
    var element = _a.element;
    return ({
        name: "BalanceHome Browse TapElement",
        parameters: {
            cdf_entity: "BalanceHome",
            cdf_action: "Browse",
            Element: element !== undefined && element !== null ? element.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BalanceHomeBrowseDidScrollContentEvent
 */
export var BalanceHomeBrowseDidScrollContent = function () { return ({
    name: "BalanceHome Browse DidScrollContent",
    parameters: {
        cdf_entity: "BalanceHome",
        cdf_action: "Browse",
    }
}); };
